import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDividerModule } from '@angular/material/divider';
import { OktaAuthModule } from '@okta/okta-angular';

/* Reusable Components */
import { ButtonComponent } from '../reusable/button/button.component';
import { ModalComponent } from '../reusable/modal/modal.component';
import { PaginationComponent } from '../reusable/pagination/pagination.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { SelectDropdownComponent } from '../reusable/select-dropdown/select-dropdown.component';
import { DividerComponent } from '../reusable/divider/divider.component';
import { InputFieldComponent } from '../reusable/input-field/input-field.component';
import { FileUploadComponent } from '../reusable/file-upload/file-upload.component';
import { ToastComponent } from '../reusable/toast/toast.component';
import { FieldDisplayComponent } from '../reusable/field-display/field-display.component';
import { SearchComponent } from '../reusable/search/search.component';
import { MultiSelectDropdownComponent } from '../reusable/multi-select-dropdown/multi-select-dropdown.component';
import { NgSelectDropdownComponent } from '../reusable/ng-select-dropdown/ng-select-dropdown.component';
import { ImageUploadComponent } from '../reusable/image-upload/image-upload.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { LinkTwoComponent } from '../template/link-two/link-two.component';

/* Directives */
import { SortableDirective } from '../reusable/sorting/sortable.directive';
import { RemoveLeadingZerosDirective } from '../reusable/number-validator/remove-leading-zeros.directive';

/* Sort UI */
import { SortdirectionComponent } from '../reusable/sortdirection/sortdirection.component';
import { SortdirectionNewComponent } from '../reusable/sortdirection/sortdirection-new/sortdirection-new.component';
import { AuditReportsComponent } from '../audit-reports/audit-reports.component';
import { AuditReportTableComponent } from '../audit-reports/audit-report-table/audit-report-table.component';
import { AppBlockingSpinnerComponent } from '../app-blocking-spinner/app-blocking-spinner.component';



@NgModule({
  declarations: [
    ButtonComponent,
    ModalComponent,
    PaginationComponent,
    SpinnerComponent,
    SelectDropdownComponent,
    DividerComponent,
    InputFieldComponent,
    FileUploadComponent,
    ToastComponent,
    FieldDisplayComponent,
    SearchComponent,
    MultiSelectDropdownComponent,
    NgSelectDropdownComponent,
    ImageUploadComponent,
    BreadcrumbComponent,
    LinkTwoComponent,
    SortableDirective,
    RemoveLeadingZerosDirective,
    SortdirectionComponent,
    SortdirectionNewComponent,
    AuditReportsComponent,
    AuditReportTableComponent,
    AppBlockingSpinnerComponent,
    AuditReportTableComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgSelectModule,
    MatDividerModule,
    OktaAuthModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgSelectModule,
    MatDividerModule,
    OktaAuthModule,
    ButtonComponent,
    ModalComponent,
    PaginationComponent,
    SpinnerComponent,
    SelectDropdownComponent,
    DividerComponent,
    InputFieldComponent,
    FileUploadComponent,
    ToastComponent,
    FieldDisplayComponent,
    SearchComponent,
    MultiSelectDropdownComponent,
    NgSelectDropdownComponent,
    ImageUploadComponent,
    BreadcrumbComponent,
    LinkTwoComponent,
    SortableDirective,
    RemoveLeadingZerosDirective,
    SortdirectionComponent,
    SortdirectionNewComponent,
    AuditReportsComponent,
    AuditReportTableComponent,
    AppBlockingSpinnerComponent,
    AuditReportTableComponent

  ]
})
export class SharedModule {}
